import Show from 'client/Show'
import Update from 'client/Update'
export default {Show, Update}
